import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row } from 'reactstrap'

import Logo from '../../Logo'

// function that scrolls to anchor
const scrollToAnchor = (anchorName) => {
  if (anchorName) {
    // Scroll
    const anchorElement = document.getElementById(anchorName)
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const PricingHeaderVariant = () => {
  const { t, i18n } = useTranslation()

  return (
    <>
      <Row className="justify-content-center pt-4">
        <Col md={3}>
          <div className="logoWrap pb-2">
            <Logo mode="dark" />
          </div>
        </Col>
      </Row>

      <Row className="pt-4 pb-3 text-center">
        <Col>
          <h1 className="headline">
            <strong>{t('Faster, easier conversions.')}</strong>
          </h1>
          <h4>
            <strong>{t('#1 rated')}</strong>{' '}
            {t('conversion rate optimizer & popup builder.')}
          </h4>
        </Col>
      </Row>
      <Row
        className="justify-content-center"
        onClick={() => scrollToAnchor('reviews')}
      >
        <Col
          sm={3}
          md={2}
          className="statWrap align-items-center justify-content-center d-flex flex-column"
        >
          <div className="stat">30,000+</div>
          <div className="subtitle">{t('Satisfied customers')}</div>
        </Col>
        <Col
          sm={3}
          md={2}
          className="statWrap align-items-center justify-content-center d-flex flex-column"
        >
          <div className="stat">
            <div className="star-rating d-block">
              <i className="mdi mdi-star" />
              <i className="mdi mdi-star" />
              <i className="mdi mdi-star" />
              <i className="mdi mdi-star" />
              <i className="mdi mdi-star" />
            </div>
          </div>
          <div className="subtitle">
            {t('Average')} <strong>5.0/5.0 {t('stars')}</strong>
          </div>
        </Col>
      </Row>
      <style jsx>
        {`
          .stat {
            font-size: 36px;
            text-align: center;
            cursor: pointer;
          }
          .stat i {
            font-size: 24px;
            color: orange;
          }
          .subtitle {
            font-size: 16px;
            color: #9b9b9b;
            text-align: center;
            cursor: pointer;
            font-weight: 300;
          }
        `}
      </style>
    </>
  )
}
export default PricingHeaderVariant
